import API from "../api";
import COMMON_API from "@/api/common.js";

export default {
  namespaced: true,
  state: {
    listInsuranceCompany: [],
    totalInsuranceCompany: 0,
    listPaymentMethods: [],
    currentInsuranceCompany: null,
    currentLegalPerson: null,
    listWalletRelationshipContact: []
  },
  mutations: {
    setListInsuranceCompany(state, payload) {
      state.listInsuranceCompany = payload.items;
      state.totalInsuranceCompany = payload.total_count;
    },
    setListPaymentMethods(state, payload) {
      state.listPaymentMethods = payload;
    },
    setCurrentInsuranceCompany(state, payload) {
      state.currentInsuranceCompany = payload;
    },
    setCurrentLegalPerson(state, payload) {
      state.currentLegalPerson = payload;
    },
    setListWalletRelationshipContact(state, payload) {
      state.listWalletRelationshipContact = payload;
    },
    updateListWalletRelationshipContact(state, payload) {
      state.listWalletRelationshipContact = state.listWalletRelationshipContact.filter(
        x => !payload.find(item => x.id === item)
      );
    }
  },
  actions: {
    async requestListInsuranceCompany({ commit }, payload) {
      const { data } = await API.getInsuranceCompany(payload);
      commit("setListInsuranceCompany", data);
      return data;
    },
    async requestNewInsuranceCompany(context, payload) {
      const { data } = await API.postInsuranceCompany(payload);
      return data;
    },
    async requestPaymentMethods({ commit }, payload) {
      const { data } = await API.getPaymentMethods(payload);
      commit("setListPaymentMethods", data);
      return data;
    },
    async requestEditInsuranceCompany(context, payload) {
      const { data } = await API.putInsuranceCompany(payload);
      return data;
    },
    async requestCurrentInsuranceCompany({ commit }, payload) {
      const { data } = await API.getCurrentInsuranceCompany(payload);
      commit("setCurrentInsuranceCompany", data);
      return data;
    },
    async requestUploadLogo(context, payload) {
      const { data } = await API.uploadLogo(payload);
      return data;
    },
    async requestLegalPerson({ commit }, payload) {
      const { data } = await COMMON_API.getPersonByCnpj(payload);
      commit("setCurrentLegalPerson", data);
      return data;
    },
    async requestWalletRelationshipContact({ commit }, payload) {
      const { data } = await API.getWalletRelationshipContact(payload);
      commit("setListWalletRelationshipContact", data);
      return data;
    },
    async updateMigrateWalletRelationshipContacts({ commit }, payload) {
      const { data } = await API.putMigrateWalletRelationshipContacts(payload);
      commit(
        "updateListWalletRelationshipContact",
        payload.payload.grupos_economicos_ids
      );
      return data;
    }
  },
  modules: {}
};
